module.exports = __webpack_public_path__ + "img/card-brand-jcb.698c8944.png";